module.exports = __webpack_public_path__ + "img/ico.729bc057.svg";